export class DfmFileState {
    loading = false;
    record: any = {};
}
